import { render, staticRenderFns } from "./BuildingAutoSearch.vue?vue&type=template&id=4f6c81e4&"
import script from "./BuildingAutoSearch.vue?vue&type=script&lang=js&"
export * from "./BuildingAutoSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports